import { useEffect, useRef, useState } from 'react'
import { MapPinCheckInside } from 'lucide-react'
import AddressMapDropdown from '../../../components/ERP/AddressMap/AddressMapDropdown'

function PatientAddressMenu({ patient }) {
  const [open, setOpen] = useState(false)
  const rootRef = useRef(null)

  useEffect(() => {
    if (!open) return undefined
    const onPointer = (event) => {
      if (!rootRef.current?.contains(event.target)) setOpen(false)
    }
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false)
    }
    document.addEventListener('pointerdown', onPointer)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('pointerdown', onPointer)
      document.removeEventListener('keydown', onKey)
    }
  }, [open])

  return (
    <div className={`patients-address-pin${open ? ' is-open' : ''}`} ref={rootRef}>
      <button
        type="button"
        className={`patients-address-btn${open ? ' is-open' : ''}`}
        aria-expanded={open}
        aria-label={`Endereço de ${patient.name}`}
        onClick={() => setOpen((current) => !current)}
      >
        <MapPinCheckInside size={18} />
      </button>
      {open && (
        <div className="patients-address-pop">
          <AddressMapDropdown
            readOnly
            defaultOpen
            shareTitle={patient.name}
            value={{
              address: patient.address || '',
              cep: patient.address_cep || '',
              latitude: patient.address_latitude,
              longitude: patient.address_longitude
            }}
            onChange={() => {}}
          />
        </div>
      )}
    </div>
  )
}

export default PatientAddressMenu
